import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrl: './games-page.component.scss',
})
export class GamesPageComponent {
  gameCards: any[] = [
    {
      title: 'Trivia',
      description: 'Guess the answer to the questions',
      buttonLabel: 'Play',
      route: 'games-v2/trivia',
      image: 'assets/images/games/games-trivia.jpg',
    },
    {
      title: 'Predictor',
      description: 'Get your predictions in before the next game',
      buttonLabel: 'Predict',
      route: 'games-v2/predictor',
      image: 'assets/images/games/games-predictor.jpg ',
    },
    {
      title: 'Polls',
      description: 'Choose your answer',
      buttonLabel: 'Vote',
      route: 'games-v2/polls',
      image: 'assets/images/games/games-polls.jpg',
    },
    {
      title: 'Pick A Player',
      description: 'Choose your answer',
      buttonLabel: 'Pick',
      route: 'games-v2/pickaplayer',
      image: 'assets/images/games/games-pick-a-player.jpg',
    },
  ];

  constructor(private router: Router) {}

  navigateByURL(route: string) {
    this.router.navigateByUrl(route);
  }
}
